import * as React from 'react';
import * as ReactDOM from 'react-dom';

const SearchBox = () => {
    const elements = document.getElementsByClassName('search-box-container');
    Array.from(elements).forEach(element => {
        const action = (element as HTMLElement).dataset.action;
        const component = (
            <form role="search" method="get" action={action} className="search-box">
                <input
                    name="query"
                    placeholder="Search..."
                    className="agile_crm_modal__input input input__input agile_crm_modal__input__error_message"
                    type="text"
                />
                <span className="clear-button" onClick={clearInput}>cancel</span>
            </form>
        );
        ReactDOM.render(component, element);
    });
};

const clearInput = (el: any) => {
    el.target.previousElementSibling.value = '';
};

export default SearchBox;
